var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.357.1h-7.7a1.5 1.5 0 00-1.5 1.5v10.8a1.5 1.5 0 001.5 1.5h7.7a1.5 1.5 0 001.5-1.5V1.6a1.5 1.5 0 00-1.5-1.5zm-7.7 1h7.7a.5.5 0 01.5.5v10.8a.5.5 0 01-.5.5h-7.7a.5.5 0 01-.5-.5V1.6a.5.5 0 01.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 2.4h-1a1.5 1.5 0 00-1.5 1.5v8.5a1.5 1.5 0 001.5 1.5h1a1.5 1.5 0 001.5-1.5V3.9a1.5 1.5 0 00-1.5-1.5zm-1 1h1a.5.5 0 01.5.5v8.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V3.9a.5.5 0 01.5-.5zM4.3 2.6a.5.5 0 01.09.992L4.3 3.6H2.8a.5.5 0 01-.09-.992L2.8 2.6h1.5zM4.3 5.2a.5.5 0 01.09.992L4.3 6.2H2.8a.5.5 0 01-.09-.992L2.8 5.2h1.5zM8 2.6a.5.5 0 01.09.992L8 3.6H6.5a.5.5 0 01-.09-.992L6.5 2.6H8zM8 5.2a.5.5 0 01.09.992L8 6.2H6.5a.5.5 0 01-.09-.992L6.5 5.2H8zM4.3 7.8a.5.5 0 01.09.992L4.3 8.8H2.8a.5.5 0 01-.09-.992L2.8 7.8h1.5zM8 7.8a.5.5 0 01.09.992L8 8.8H6.5a.5.5 0 01-.09-.992L6.5 7.8H8zM4.3 10.4a.5.5 0 01.09.992l-.09.008H2.8a.5.5 0 01-.09-.992l.09-.008h1.5zM8 10.4a.5.5 0 01.09.992L8 11.4H6.5a.5.5 0 01-.09-.992l.09-.008H8z"
  }))));
}

export default SvgCrmHome;